// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lh-0";